import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { useErrorContext } from '@qpr/client-library';
import React, { useEffect, useState } from 'react';
import ReactGridLayout from 'react-grid-layout';
import ValueInputButton from '../ValueInputLink/ValueInputButton';
import initialState, { ConfigurableGridState } from './configurable-grid-state';
import { ViewModelType } from './configurable-grid-view-model';
import ConfigurableGrid from './ConfigurableGrid';

const PREFIX = 'ConfigurableGridView';

const classes = {
  title: `${PREFIX}-title`,
  subtitle: `${PREFIX}-subtitle`
};

const Root = styled('div')(({ theme }) => ({
  [`& .${classes.title}`]: {
    paddingLeft: theme.spacing(3),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(1)
  },

  [`& .${classes.subtitle}`]: {
    paddingLeft: theme.spacing(3),
    paddingBottom: theme.spacing(1)
  }
}));

interface ConfigurableGridViewProps {
  viewModel: ViewModelType;
}

const ConfigurableGridView = ({ viewModel }: ConfigurableGridViewProps) => {
  const [data, setData] = useState<ConfigurableGridState>();
  const [inited, setInited] = useState<Boolean | null>(false);
  const { setError } = useErrorContext();

  const putToMongo = (value: ReactGridLayout.Layouts) => {
    console.log('This is the layout id:', data?.data._id);
    console.log('TODO: should PUT this to server:', value);
    const dimensionsArray = value.lg.map((item: any) => {
      return { w: item.w, y: item.y, h: item.h, x: item.x };
    });
    console.log(dimensionsArray);
    const newSections = data?.data.sections.map((section: any, index: number) => {
      return { ...section, dimensions: dimensionsArray[index] };
    });
    console.log(newSections);

    viewModel.updateData(data!.data._id, { sections: newSections });
  };

  useEffect(() => {
    const initData = async () => {
      setInited(false);
      const viewModelData = await viewModel.getData();
      if (viewModelData.error?.message) {
        setInited(null);
        setError(viewModelData.error);
        setData(initialState);
        return;
      }
      setData(viewModelData);
      setInited(true);
    };
    if (inited !== null) initData();
  }, [viewModel]);

  const getTitle = (gridData: ConfigurableGridState) =>
    gridData.data.title ? (
      <Typography className={classes.title} variant="h5">
        {gridData.data.title}
      </Typography>
    ) : null;

  const getSubtitle = (gridData: ConfigurableGridState) =>
    gridData.data.subtitle ? (
      <Typography className={classes.subtitle} variant="body2">
        {gridData.data.subtitle}
      </Typography>
    ) : null;

  // eslint-disable-next-line no-nested-ternary
  return inited !== false ? (
    data?.data ? (
      <Root data-testid="configurableGrid">
        <Grid container>
          <Grid item xs={12} md={10}>
            {getTitle(data)}
            {getSubtitle(data)}
          </Grid>
          <Grid item xs={12} md={2}>
            <ValueInputButton />
          </Grid>
        </Grid>
        <ConfigurableGrid contents={data.data.sections} onSave={putToMongo} />
      </Root>
    ) : null
  ) : (
    <div data-testid="loadingIndicator" style={{ width: '40px', margin: 'auto' }}>
      <CircularProgress />
    </div>
  );
};

export default ConfigurableGridView;
